import { LitElement, html, unsafeCSS } from "lit-element"
import { classMap } from "lit-html/directives/class-map"
// import { styleMap } from "lit-html/directives/style-map"
import commonStyle from "../common.css"
import style from "./appbar.css"

export default class extends LitElement {
	static styles = [unsafeCSS(style), unsafeCSS(commonStyle)]
	static get properties () {
		return {
			appTitle: { type: String, attribute: "app-title" },
			subTitle: { type: String, attribute: "sub-title" },
			hasNav: { type: Boolean, attribute: "has-nav" },
			navIcon: { type: String, attribute: "nav-icon" },
			dense: { type: Boolean }
		}
	}

	constructor () {
		super()
		this.appTitle = ""
		this.subTitle = ""
		this.hasNav = false
		this.navIcon = "fas fa-bars"
		this.dense = false
	}

	render () {
		return html`
		<header class=${this.headerClass}>
			<div class="header-left">
				${this.hasNav ? html`<bui-icon ripple class="icon icon-button hl" icon=${this.navIcon} @click="${this.#toggleNav}"></bui-icon>` : ""}
				<div class="title-wrapper">
					<span class="title" @click="${this.#titleClicked}">${this.appTitle}</span>
					${(this.appTitle && this.subTitle) ? html`<div class="separator hide-on-sp"></div>` : ""}
					<span class="sub-title hide-on-sp">${this.subTitle}</span>
				</div>
			</div>
			<div class="header-right">
				<slot></slot>
			</div>
		</header>
    `
	}

	get headerClass () {
		return classMap({
			header: true,
			shadow: true,
			primary: true,
			dense: this.dense
		})
	}

	#toggleNav () {
		this.dispatchEvent(new CustomEvent("nav-click"))
	}

	#titleClicked () {
		this.dispatchEvent(new CustomEvent("title-click"))
	}
}
